<div class="container">
    <article>
        <br/>
        <h1><span class="orange" style="font-size: 1.85rem;">Round Table zum Multiplen Myelom</span><br/>Therapie des frühen Rezidivs mit BCMA-gerichtetem Antikörper-Wirkstoff-Konjugat (ADC)</h1>
        <h1>Mittwoch, 16. September 2026<br/>
            Dorint Hotel Hamburg-Eppendorf</h1>

        <p>Wir laden Sie herzlich zu einem wissenschaftlichen Austausch
ein, der sich der <b>Therapie des multiplen Myeloms im frühen
Rezidiv</b> widmet. Im Mittelpunkt stehen <b>BCMA-gerichtete
Antikörper-Wirkstoff-Konjugate (ADCs)</b> sowie deren klinische
Relevanz und Einordnung in moderne Therapiesequenzen
(u. a. CAR T, CD38 basierte Triplets, bispezifische Antikörper).</p>

<p>Gemeinsam diskutieren wir, für welche Patient:innen und in
welchen Behandlungssituationen ADCs besonders geeignet
sind und wie sie sich sinnvoll vor bzw. zwischen anderen
Immuntherapien sequenzieren lassen. Aktuelle Studiendaten
werden dabei praxisnah eingeordnet.</p>

<p>Unter der Leitung von <b>Prof. Dr. Katja Weisel</b> bietet
diese Veranstaltung eine Kombination aus Fachvortrag,
Diskussion klinischer Erfahrungen sowie Gelegenheit zum
interdisziplinären Austausch.</p>

<p>Wir freuen uns auf Ihre Teilnahme und einen wertvollen
wissenschaftlichen Dialog.</p>

        <div class="app-registration greyBackground" *ngIf="showRegistrationFormView">
            <form name="form" #f="ngForm">
                <div class="cross-validation">
                    <div class="form-group" *ngIf="breakoutGroups.length > 0">
                        <select id="selectedBreakoutGroupId" name="selectedBreakoutGroupId" [(ngModel)]="selectedBreakoutGroupId" class="form-control">
                            <option *ngFor="let group of breakoutGroups" [ngValue]="group._id">{{group.name}}</option>
                        </select>
                        <label>{{ "registration.labels.participation" | translate }}*</label>
                    </div>

                    <div class="form-group">
                        <input id="firstName" name="firstname" #firstNameInput="ngModel" [(ngModel)]="this.registration.firstname" type="text" class="form-control" required />
                        <label>{{ "registration.labels.first_name" | translate }}*</label>
                        <div class="validation-error alert alert-danger" *ngIf="firstNameInput?.errors?.required && (firstNameInput.dirty || firstNameInput.touched)">
                            <p>{{ "registration.validation.first_name" | translate }}</p>
                        </div>
                    </div>

                    <div class="form-group">
                        <input id="lastName" name="lastName" #lastNameInput="ngModel" [(ngModel)]="this.registration.lastname" type="text" class="form-control" required />
                        <label>{{ "registration.labels.last_name" | translate }}*</label>
                        <i class="form-group__bar"></i>
                        <div class="validation-error alert alert-danger" *ngIf="lastNameInput.errors?.required && (lastNameInput.dirty || lastNameInput.touched)">
                            <p>{{ "registration.validation.last_name" | translate }}</p>
                        </div>
                    </div>

                    <div class="form-group">
                        <input id="email" name="email" #emailInput="ngModel" [(ngModel)]="this.registration.email" type="email" class="form-control" required email />
                        <label>{{ "registration.labels.email" | translate }}*</label>
                        <div class="validation-error alert alert-danger" *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)">
                            <p>{{ "registration.validation.email" | translate }}</p>
                        </div>
                    </div>

                    <div class="form-group">
                        <input id="institution" name="institution" #institutionInput="ngModel" [(ngModel)]="this.registration.misc.institution" type="text" class="form-control" required />
                        <label>{{ "registration.labels.institution" | translate }}*</label>
                        <i class="form-group__bar"></i>
                        <div class="validation-error alert alert-danger" *ngIf="institutionInput.errors?.required && (institutionInput.dirty || institutionInput.touched)">
                            <p>{{ "registration.validation.institution" | translate }}</p>
                        </div>
                    </div>

                    <div class="form-group">
                        <input id="dietaryNeeds" name="dietaryNeeds" #dietaryNeedsInput="ngModel" [(ngModel)]="this.registration.misc.dietaryneeds" type="text" class="form-control" required />
                        <label>{{ "registration.labels.dietaryNeeds" | translate }}*</label>
                        <i class="form-group__bar"></i>
                        <div class="validation-error alert alert-danger" *ngIf="dietaryNeedsInput.errors?.required && (dietaryNeedsInput.dirty || dietaryNeedsInput.touched)">
                            <p>{{ "registration.validation.dietaryNeeds" | translate }}</p>
                        </div>
                    </div>

                    <div class="form-group form-group--float form-group--centered">
                        <input id="agbAccepted" #agbAcceptedInput="ngModel" name="agbAccepted" [(ngModel)]="this.registration.agbAccepted" type="checkbox" required />
                        <label id="agbAcceptLabel" for="agbAccepted">{{ "registration.labels.accept" | translate }}</label>
                        <div class="validation-error alert alert-danger" *ngIf="agbAcceptedInput.errors?.required && (agbAcceptedInput.dirty || agbAcceptedInput.touched)">
                            <p>{{ "registration.validation.terms_accepted" | translate }}</p>
                        </div>
                    </div>

                    <div class="form-group">
                        <label [innerHtml]="'registration.labels.termsnotes' | translate"></label>
                    </div>

                    <button class="btn btn-primary btn-block" type="submit" (click)="register()" [disabled]="f.invalid">
                        {{ "registration.buttons.register" | translate }}
                    </button>
                </div>
            </form>
        </div>

        <div class="app-registration-successful" *ngIf="showRegistrationSuccessfulView">
            <h4>Vielen Dank für Ihre Registrierung!</h4>
            <p>Ihre Anmeldung zum Round Table am 26. August 2026 im Dorint Hotel
               Hamburg-Eppendorf ist eingegangen. Sie erhalten in Kürze eine
               Bestätigung per E-Mail. Wir freuen uns auf Ihre Teilnahme!</p>
        </div>

        <section>
            <table class="mt-3 mb-3" style="width:100%;">
                <tr class="orange strong">
                    <td>17:30 – 17:45</td>
                    <td>Einlass &amp; Empfang</td>
                </tr>
                <tr class="strong">
                    <td></td>
                    <td>Begrüßungskaffee und Möglichkeit zum ersten Austausch</td>
                </tr>
                <tr class="table-spacer">
                    <td colspan="10"></td>
                </tr>
                <tr class="orange strong">
                    <td>17:45 – 18:00</td>
                    <td>Begrüßung durch den Chair</td>
                </tr>
                <tr class="strong">
                    <td></td>
                    <td><i>Frau Prof. Dr. Katja Weisel</i></td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <ul>
                            <li>Einführung in das Thema</li>
                            <li>Einordnung des frühen Rezidivs beim Multiplen Myelom</li>
                        </ul>
                    </td>
                </tr>
                <tr class="table-spacer">
                    <td colspan="10"></td>
                </tr>
                <tr class="orange strong">
                    <td>18:00 – 19:00</td>
                    <td>Fachvortrag</td>
                </tr>
                <tr class="strong">
                    <td></td>
                    <td><i>Frau Prof. Dr. Katja Weisel</i></td>
                </tr>
                <tr class="strong">
                    <td></td>
                    <td>BCMA-gerichtete ADCs im frühen Rezidiv – aktueller Stand, Evidenz und praktische Relevanz</td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        Schwerpunkte:
                        <ul>
                            <li>Rationale für BCMA als therapeutisches Target</li>
                            <li>Überblick über verfügbare ADCs und aktuelle Studiendaten</li>
                            <li>Patientenselektion, Response, Sicherheit</li>
                            <li>Integration in bestehende Therapiesequenzen (u. a. CAR T, CD38 basierte Triplets, bispezifische Antikörper) – „Für wen ist was das Richtige“</li>
                            <li>Aktuelle Studien</li>
                        </ul>
                    </td>
                </tr>
                <tr class="table-spacer">
                    <td colspan="10"></td>
                </tr>
                <tr class="orange strong">
                    <td>19:00 – 19:30</td>
                    <td>Moderierte Diskussionsrunde</td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <ul>
                            <li>Klinische Erfahrungen im Alltag</li>
                            <li>Herausforderungen in der Versorgung</li>
                            <li>Q&amp;A mit dem Publikum</li>
                        </ul>
                    </td>
                </tr>
                <tr class="table-spacer">
                    <td colspan="10"></td>
                </tr>
                <tr class="orange strong">
                    <td>ab 19:30</td>
                    <td>Get-together &amp; informeller Austausch</td>
                </tr>
                <tr class="strong">
                    <td></td>
                    <td>Kleiner Imbiss</td>
                </tr>
            </table>
        </section>

        <section class="icons">
            <div class="row">
                <div class="col-sm-6 col-lg d-grid justify-content-center">
                    <a href="assets/img/landingpages/round-table-mm/GSK Round Table zum Multiplen Myelom.ics" download onclick="clicktracker.click('landingpage -> calendar');">
                        <p><mat-icon>date_range</mat-icon></p>
                        <p>Kalendereintrag</p>
                    </a>
                </div>
            </div>
        </section>

        <section>
            <h2>Kontakt:</h2>

            <p>Ruzica Paape</p>
            <p>Tel.: +49 172 1569942</p>
            <p>E-Mail: <a href="mailto:ruzica.x.paape@gsk.com ">ruzica.x.paape@gsk.com </a></p>
        </section>


        <p class="footnote">
            * Die erhobenen, personenbezogenen Daten dienen ausschließlich der Teilnehmerverwaltung (Veranstalter und Partner) in Zusammenhang mit dieser Veranstaltung. Weitere Informationen finden Sie hier:
            <a href="https://de.gsk.com/de-de/datenschutzerklaerung/" target="_blank">https://de.gsk.com/de-de/datenschutzerklaerung/</a>
            <br/><br/>
            <span style="font-size: 0.85rem;">NP-DE-BLM-LBND-260014, Juni 2026</span>
        </p>

    </article>
</div>
